import { ArrowDown } from '@untitledui/icons/ArrowDown';
import { ArrowUp } from '@untitledui/icons/ArrowUp';
import { ArrowLeft } from '@untitledui/icons/ArrowLeft';
import { ArrowRight } from '@untitledui/icons/ArrowRight';
import { ArrowNarrowRight } from '@untitledui/icons/ArrowNarrowRight';
import { ChevronRight } from '@untitledui/icons/ChevronRight';
import { ChevronDown } from '@untitledui/icons/ChevronDown';
import { ChevronLeft } from '@untitledui/icons/ChevronLeft';
import { Home01 } from '@untitledui/icons/Home01';
import { Plus } from '@untitledui/icons/Plus';
import { Minus } from '@untitledui/icons/Minus';
import { SearchLg } from '@untitledui/icons/SearchLg';
import { XClose } from '@untitledui/icons/XClose';
import { PhoneCall01 } from '@untitledui/icons/PhoneCall01';
import { MarkerPin03 } from '@untitledui/icons/MarkerPin03';
import { Menu05 } from '@untitledui/icons/Menu05';
import { Play } from '@untitledui/icons/Play';
import { Copy01 } from '@untitledui/icons/Copy01';
import { FilterLines } from '@untitledui/icons/FilterLines';
import { FileSearch02 } from '@untitledui/icons/FileSearch02';

export const ICON_MAP = {
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowNarrowRight: ArrowNarrowRight,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  home: Home01,
  plus: Plus,
  minus: Minus,
  search: SearchLg,
  close: XClose,
  chevronLeft: ChevronLeft,
  phone: PhoneCall01,
  markerPin: MarkerPin03,
  menu: Menu05,
  play: Play,
  copy: Copy01,
  filterLines: FilterLines,
};
